import {requestOptions} from "./base";

export const getAdvertiser = () => (
  requestOptions('adv', {
    method: 'GET',
  })
);

export const updateAdvertiser = () => (
  requestOptions('adv', {
    method: 'PATCH',
  })
);

export const updateAdvertiserPassword = () => (
  requestOptions('adv/password', {
    method: 'PATCH',
  })
);

export const forgotAdvertiserPassword = () => (
  requestOptions('adv/forgot-password', {
    method: 'POST',
  })
);
